import React from 'react';
import { createRoot } from 'react-dom/client';
import V2App from './V2App';
import './index.css';

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root element not found');
}

const root = createRoot(container);
root.render(<V2App />);